import { RootState } from "@/store/store";
import { languageSelector } from "@/store/language-select/selectors/languageSelector";

/**
 * A helper function that wraps an RTK Query selector and automatically includes the language parameter.
 * This reduces repetitive code by eliminating the need to manually inject the language in multiple places.
 *
 * @param selector The RTK Query selector function to wrap
 * @returns A new selector function that automatically includes the language parameter
 */
export const wrapSelectorWithLanguage = <T, P>(
  selector: (
    params: P & { language?: string },
  ) => (state: RootState) => T | undefined,
) => {
  return (params: Omit<P, "language">) => (state: RootState) => {
    const language = languageSelector(state);
    return selector({ ...(params as any), language })(state);
  };
};
